var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCriativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.422,
    height: 74.929,
    viewBox: "0 0 87.422 74.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "criativo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(11.392 13.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M305.918,280.02a4.85,4.85,0,0,0-1.435,3.447v0a4.861,4.861,0,0,0,4.861,4.861h.068a5.161,5.161,0,0,0,5.16,5.041h2.764a5.161,5.161,0,0,0,5.16-5.041h.182a4.861,4.861,0,0,0,4.861-4.861v0a4.844,4.844,0,0,0-1.435-3.447,5.162,5.162,0,0,0,1.435-3.571c0-2.467,0-5.62.039-7.568v-.032a2.121,2.121,0,0,1,.831-1.681l.026-.02a20.018,20.018,0,1,0-24.824.057l.018.014a2.155,2.155,0,0,1,.856,1.72v7.509a5.162,5.162,0,0,0,1.435,3.571Zm6.5,8.311h7.072a2.158,2.158,0,0,1-2.154,2.037h-2.764A2.158,2.158,0,0,1,312.418,288.331Zm12.116-4.864v0a1.857,1.857,0,0,1-1.857,1.857H309.346a1.857,1.857,0,0,1-1.858-1.857v0a1.857,1.857,0,0,1,1.857-1.857h13.333A1.857,1.857,0,0,1,324.534,283.467Zm-7.021-4.861h4.864a2.159,2.159,0,0,0,2.157-2.157c0-2.482,0-5.651.039-7.6a5.124,5.124,0,0,1,1.99-4.051,17.013,17.013,0,1,0-21.114.035,5.159,5.159,0,0,1,2.038,4.107v7.511a2.159,2.159,0,0,0,2.157,2.157h4.864V261.312a8.383,8.383,0,0,1-6.874-8.241,1.5,1.5,0,1,1,3,0,5.372,5.372,0,0,0,10.743,0,1.5,1.5,0,1,1,3,0,8.383,8.383,0,0,1-6.874,8.241Z",
    transform: "translate(-295.968 -231.556)",
    fill: "#7d0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    transform: "translate(29.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M131.307,190.677v4.2a1.5,1.5,0,1,0,3,0v-4.2a1.5,1.5,0,1,0-3,0Z",
    transform: "translate(-131.307 -189.176)",
    fill: "#7d0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147",
    transform: "translate(0 32.726) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M0,1.5V5.7a1.5,1.5,0,0,0,3,0V1.5a1.5,1.5,0,1,0-3,0Z",
    fill: "#7d0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(7.992 10.222) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M0,1.5V5.7a1.5,1.5,0,1,0,3,0V1.5a1.5,1.5,0,1,0-3,0Z",
    fill: "#7d0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(52.124 7.992) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M0,1.5V5.7a1.5,1.5,0,1,0,3,0V1.5a1.5,1.5,0,1,0-3,0Z",
    fill: "#7d0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(62.346 29.618) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M0,1.5V5.7a1.5,1.5,0,0,0,3,0V1.5a1.5,1.5,0,1,0-3,0Z",
    fill: "#7d0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(64.694 30.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M239.9,187.277v-10.31a3.564,3.564,0,0,0-3.564-3.564h-10.31a3.564,3.564,0,0,0-3.564,3.564v10.31a3.564,3.564,0,0,0,3.564,3.564h10.31A3.564,3.564,0,0,0,239.9,187.277Zm-3-10.31v10.31a.56.56,0,0,1-.56.56h-10.31a.56.56,0,0,1-.56-.56v-10.31a.56.56,0,0,1,.56-.56h10.31A.56.56,0,0,1,236.9,176.967Z",
    transform: "translate(-222.465 -173.403)",
    fill: "#7d0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    transform: "translate(64.694 50.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M239.9,187.277v-10.31a3.564,3.564,0,0,0-3.564-3.564h-10.31a3.564,3.564,0,0,0-3.564,3.564v10.31a3.564,3.564,0,0,0,3.564,3.564h10.31A3.564,3.564,0,0,0,239.9,187.277Zm-3-10.31v10.31a.56.56,0,0,1-.56.56h-10.31a.56.56,0,0,1-.56-.56v-10.31a.56.56,0,0,1,.56-.56h10.31A.56.56,0,0,1,236.9,176.967Z",
    transform: "translate(-222.465 -173.403)",
    fill: "#7d0000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153",
    transform: "translate(64.827 6.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M346.9,231.35a3.553,3.553,0,0,0-2.689-1.226H333.9a3.565,3.565,0,0,0-3.565,3.565V244a3.564,3.564,0,0,0,3.565,3.565h10.311A3.565,3.565,0,0,0,347.771,244v-9.276l4.715-4.715a1.5,1.5,0,0,0-2.124-2.126Zm-2.159,2.159a.56.56,0,0,0-.53-.38H333.9a.56.56,0,0,0-.56.56V244a.56.56,0,0,0,.56.56h10.311a.56.56,0,0,0,.56-.56v-6.271l-3.829,3.829a1.5,1.5,0,0,1-2.124,0l-2.887-2.887a1.5,1.5,0,1,1,2.124-2.126l1.825,1.825Z",
    transform: "translate(-330.331 -227.443)",
    fill: "#7d0000",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriativo);
export default __webpack_public_path__ + "static/media/criativo.23d9027ff9c395d378679d83b1798d2f.svg";
export { ForwardRef as ReactComponent };